import { useCallback } from 'react';
import { GetRefinanceRequestQuery } from '../../GraphQL.Loan';
import { DisclosureModel } from '../../GraphQL.LoanApplication';
import { Disclosure } from '../../loan-application/review-disclosures/disclosure';
import { ModelState } from '../../shared/ModelState';

type ModelWithDisclosures = Pick<NonNullable<GetRefinanceRequestQuery['getRefinanceRequest']>, 'disclosures'>;

interface RefinanceDisclosuresProps<T extends ModelWithDisclosures> {
    model: T;
    onChange?: (model: T) => void;
    modelState: ModelState;
    disabled?: boolean;
    showError: boolean;
    variables?: Record<string, string>;
}

export function RefinanceDisclosures<T extends ModelWithDisclosures>(props: RefinanceDisclosuresProps<T>) {
    const { model, onChange, disabled, showError, variables } = props;
    const handleChange = useCallback(
        (disc: Partial<DisclosureModel>) =>
            model && onChange?.({ ...model, disclosures: model?.disclosures?.map((x) => (x.id === disc.id ? { ...x, ...disc } : x)) }),
        [onChange, model]
    );
    return (
        <>
            {model?.disclosures?.map(function (disclosure, i) {
                disclosure.id ??= `disclosure_${i}`;
                return (
                    <Disclosure
                        disclosure={disclosure}
                        key={i}
                        onChange={handleChange}
                        disabled={disabled}
                        showError={showError}
                        variables={variables}
                        />
                );
            })}
        </>
    );
}
